import {inject, observer} from "mobx-react";
import * as React from "react";
import {Toast} from "react-bootstrap";
import {INotice, NoticeTypeEnum} from "../../models/notice";
import ToasterStore from "../../stores/toaster-store";
import Base, {IBaseProps} from "../base";
import './toaster.css';

interface IToasterProps extends IBaseProps {
    toasterStore?: ToasterStore;
}

@inject('rootStore', 'toasterStore')
@observer
export default class Toaster extends Base<IToasterProps> {
    private static renderMessage(notice: INotice): JSX.Element {
        if (notice.type === NoticeTypeEnum.Success) {
            return <strong className="text-success">{notice.message}</strong>;
        }

        if (notice.type === NoticeTypeEnum.Failure) {
            return <strong className="text-danger">{notice.message}</strong>;
        }

        return <strong>{notice.message}</strong>;
    }

    public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const notices = this.props.toasterStore.notices;

        if (notices) {
            return <div aria-live="polite" aria-atomic="true" className="div-toast">
                <div className="toast-content">
                    {notices.map((notice, idx) => this.renderNotice(notice, idx))}
                </div>
            </div>;
        }

        return null;
    }

    private renderHeader(noticeType: NoticeTypeEnum): JSX.Element {
        if (noticeType === NoticeTypeEnum.Failure) {
            return <div className="mr-auto text-danger">
                <i className="fa fa-exclamation-triangle"/>
                <strong className="ml-1 text-uppercase">{this.translate("toaster.error", "Error")}</strong>
            </div>;
        }

        if (noticeType === NoticeTypeEnum.Success) {
            return <div className="mr-auto text-success">
                <i className="fa fa-check-circle"/>
                <strong className="ml-1 text-uppercase">{this.translate("toaster.success", "Success")}</strong>
            </div>;
        }

        return <strong className="mr-auto text-info text-uppercase"/>;
    }

    private renderNotice(notice: INotice, idx: number): JSX.Element {
        return <Toast id={`notice-${idx}`} key={idx} autohide={true} onClose={this.setNotices(idx)}
                      className="animated fadeInRight">
            <Toast.Header>
                {this.renderHeader(notice.type)}
            </Toast.Header>
            <Toast.Body>
                {Toaster.renderMessage(notice)}
            </Toast.Body>
        </Toast>;
    }

    private setNotices = (idx: number) => () => {
        document.getElementById(`notice-${idx}`).classList.add("fadeOutRight");
        setTimeout(() => this.props.toasterStore.setNotices(), 1000);
    }
}



// WEBPACK FOOTER //
// ./src/components/toaster/toaster.tsx